import { IUpdateArquivoGenericoUseCase } from "../../../presentation/useCases/update/update_arquivo_generico_use_case";
import { IUpdateConfigPagamentoUseCase } from "../../../presentation/useCases/update/update_config_pagamento_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// UpdateConfigPagamentoUseCase


export class UpdateConfigPagamentoUseCase implements IUpdateConfigPagamentoUseCase
 {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateConfigPagamento(
  IdPgtoMedicao: number, IdMedicaoTerceirizacao: number | null, Nome: string | null, AVista: number | null, NrParcelas: number | null, TipoData: number | null, NroDias: number | null, ValorTotal: number | null, DataPgto: Date | null,  IdTipoConta: number | null, FormaPagamento: string | null, Observacao: string | null, InformacoesGerais: string | null, NrNotaFiscalEspecifica: string | null, ValorEntrada: number | null, DataEntrada: Date | null,  IdSubconta: number | null
  ): Promise<void> {
    
    await this.repository.updateConfigPagamento(
     IdPgtoMedicao, IdMedicaoTerceirizacao, Nome, AVista, NrParcelas, TipoData, NroDias, ValorTotal, DataPgto,  IdTipoConta, FormaPagamento, Observacao, InformacoesGerais, NrNotaFiscalEspecifica, ValorEntrada, DataEntrada, IdSubconta
    );
  }
}
